import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../Store";
export interface IRouting {
  title: string;
  routes: {
    id: number;
    icon: string;
    is_side: boolean;
    to: string;
    element: string;
    content: string;
  }[];
}
const initialState: IRouting[] | [] = [];

// маршруты
const routingSlice = createSlice({
  name: "ROUTING_SLICE",
  initialState: initialState,
  reducers: {
    // обновить маршруты
    UP_DATE_ROUTING: (state, actions: PayloadAction<IRouting[], string>) => {
      return (state = actions.payload);
    },
  },
});

export const selectRouts = (state: RootState) => state.routingSlice;
export const { UP_DATE_ROUTING } = routingSlice.actions;
export default routingSlice.reducer;
